module.exports = __webpack_public_path__ + "static/media/NOBAlogo.be410868.svg";